import React from 'react';
import { Spin, Row, Col } from 'antd';
import { isEmpty } from 'lodash-es';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { Waypoint } from 'react-waypoint';
import { centresSelectors } from 'redux/centres/selectors';

import EmptyData from 'components/common/EmptyData';

import CentresListCustomStyles from './styles';
import CentresCard from '../CentresCard';

const CentresListCustom = ({ retrieveList, resourceData, ...props }) => {
  const loading = useSelector((state) => state.centres.loading);
  const enabledLoadMore = useSelector(centresSelectors.enabledLoadMore);
  const resourceFilter = useSelector(centresSelectors.getFilters) || {};

  const handleEnterWaypoint = () => {
    retrieveList({
      filter: {
        filter: resourceFilter.filter,
        orderBy: '-updatedAt',
      },
      isRefresh: false,
    });
  };

  return (
    <CentresListCustomStyles>
      {isEmpty(resourceData) ? (
        <EmptyData />
      ) : (
        <Row gutter={[24, 24]} className="row-locations-list">
          {resourceData.map((item, index) => (
            <Col key={String(index)} xxl={6} xl={6} lg={8} md={8} xs={24}>
              <CentresCard record={item} {...props} />
            </Col>
          ))}
        </Row>
      )}
      {loading && (
        <div className="loading-centres">
          <Spin />
        </div>
      )}
      {enabledLoadMore && <Waypoint onEnter={handleEnterWaypoint} />}
    </CentresListCustomStyles>
  );
};

CentresListCustom.propTypes = {
  resourceData: PropTypes.array,
  retrieveList: PropTypes.func,
  resourceFilter: PropTypes.object,
};

export default CentresListCustom;
